import React from "react";
import "./style.scss";
import successIcon from "../../../assets/icons/successModalIcon.svg";
import {useDispatch, useSelector} from "react-redux";
import {clearMessages} from "../../../store/reducers/message";

function SuccessModal() {
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  // const {t} = useTranslation();

  const handleClose = (e) => {
    if (e) e.preventDefault();
    setOpen(false);
    dispatch(clearMessages());
  };

  const {title, msg, status} = useSelector((state) => state.message);

  React.useEffect(() => {
    setOpen(true);
  });

  return msg && status ? (
    <div
      className="success_modal_overlay"
      onClick={() => handleClose(false)}
    >
      <div className="success_modal_container successPopupContainer">
        <div
          className="success_modal_container_top popupMessageTopSection"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="tick_icon popupIcon">
            <img
              src={successIcon}
              alt="successful tick"
            />
          </div>
        </div>

        <div
          className="success_modal_container_bottom popupMessageBottomSection"
          onClick={(e) => e.stopPropagation()}
        >
          <h1>Success!</h1>
          <p>{msg}</p>
          <button
            className="success_modal_close_btn"
            onClick={() => handleClose(false)}
          >
            {"Ok"}
          </button>
        </div>
      </div>
    </div>
  ) : (
    false
  );
}

export default SuccessModal;
